export interface ProductRequestReview_interface {
    id:number,
    title:String,
    username:String,
    dsc:String,
    persianDate:String,
    del:boolean,
    type:number,
    option:Array<string>,
  }
  
  export function Empty_ProductRequestReview_interface():ProductRequestReview_interface{
    return{
      id:0,
      title: '',
      username: '',
      dsc:'',
      persianDate:'',
      del:false,
      type: 0,
      option:[]
    }
  }
  